import { Home, TaskRecurrence, TaskType } from '@lmc/ts-common'
import { Tag, theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Tooltip } from 'antd'
import { getNominative } from 'common/utils'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type TaskTagsProps = {
  recurrence?: TaskRecurrence | undefined
  taskType: TaskType
  typeOnly?: boolean
  doubleSignature?: boolean
  logScreenPrompt?: boolean
}
const TaskTags = ({
  recurrence,
  taskType,
  typeOnly = false,
  doubleSignature = false,
  logScreenPrompt = false,
}: TaskTagsProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)
  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  let typeColor: string
  let typePopoverText: string
  let taskTypeText = taskType.toUpperCase()

  if (taskType === 'home') {
    typeColor = 'green'
    typePopoverText = t(toDosConstants.HOME_TAG)
  } else if (taskType === 'team') {
    typeColor = 'cyan'
    typePopoverText = t(toDosConstants.TEAM_TAG)
  } else {
    typeColor = 'purple'
    typePopoverText = t(toDosConstants.RESIDENT_TAG)
    taskTypeText = getNominative(
      preferredPeopleNominative,
      'Resident'
    ).toUpperCase()
  }

  const calculateType = (type: string) => {
    if (type.toLocaleUpperCase() === 'SERVICE USER') {
      return 'SU'
    }
    if (type.toLocaleUpperCase() === 'SUPPORTED PERSON') {
      return 'SP'
    }
    return type
  }

  return (
    <Wrapper>
      <Tooltip
        title={<TooltipText>{typePopoverText}</TooltipText>}
        color={theme.color.neutral.color3}
      >
        <Tag color={typeColor}>{calculateType(taskTypeText)}</Tag>
      </Tooltip>

      {!typeOnly && (
        <>
          <Tooltip
            title={<TooltipText>{t(toDosConstants.ONE_OFF_TAG)}</TooltipText>}
            color={theme.color.neutral.color3}
          >
            {recurrence === TaskRecurrence.once && (
              <Tag color="red">{t(toDosConstants.ONE_OFF)}</Tag>
            )}
          </Tooltip>
          <Tooltip
            title={
              <TooltipText>
                {t(toDosConstants.SECOND_SIGNATURE_TAG)}
              </TooltipText>
            }
            color={theme.color.neutral.color3}
          >
            {doubleSignature && (
              <Tag color="geekblue">{t(toDosConstants.SECOND_SIGNATURE)}</Tag>
            )}
          </Tooltip>
          <Tooltip
            title={<TooltipText>{t(toDosConstants.DAILY_LOG_TAG)}</TooltipText>}
            color={theme.color.neutral.color3}
          >
            {logScreenPrompt && (
              <Tag color="pink">{t(toDosConstants.DAILY_LOG)}</Tag>
            )}
          </Tooltip>
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const TooltipText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color11};
`

export default TaskTags
